import Tooltip from '../../components/Tooltip/Tooltip';

import { ReactComponent as JanusLogo } from '../../assets/janus-logo.svg';

export const JanusLink = ({ itemTextClassname, threatCounterClassname }) => {
  const counterValue = 1;

  return (
    <a href="https://janus.osavul.cloud/demo" target="_blank" rel="noreferrer" className="nav-link">
      <Tooltip
        content={'Janus'}
        position="right"
      >
        <div className="iconWrapper">
          <JanusLogo />
          <span className="threatCounter">{counterValue}</span>
        </div>
      </Tooltip>

      <span className={itemTextClassname}>
        Janus
        <div className={threatCounterClassname}>{counterValue}</div>
      </span>
    </a>
  );
};
